// vim: set ts=2 sts=2 sw=2 et:

import React from "react";

interface Props {
  items: ReadonlyArray<string>;
  maxFontSize: number;
  minFontSize: number;
  className?: string;
  ariaLabel?: string;
}

// Una fila de datos cortos (país, provincia, equipo) en una sola línea: achica la letra hasta que entra, como
// FitLine con los nombres. Si ni al mínimo entra, marca `data-fit="clamped"` y el CSS corta el último dato con
// "…". Mide al cambiar los datos: los lienzos son de ancho fijo (1920px escalados con transform).
const FitRow = ({ items, maxFontSize, minFontSize, className, ariaLabel }: Props) => {
  const ref = React.useRef<HTMLUListElement>(null);
  const text = items.join("\n");

  React.useLayoutEffect(() => {
    const element = ref.current;
    if (element === null) return;
    let fontSize = maxFontSize;
    element.style.fontSize = `${fontSize}px`;
    element.dataset.fit = "single";
    while (fontSize > minFontSize && element.scrollWidth > element.clientWidth) {
      fontSize -= 1;
      element.style.fontSize = `${fontSize}px`;
    }
    if (element.scrollWidth > element.clientWidth) element.dataset.fit = "clamped";
  }, [text, maxFontSize, minFontSize]);

  return (
    <ul ref={ref} className={className} aria-label={ariaLabel}>
      {items.map((item, index) => (
        <li key={`${index}:${item}`}>{item}</li>
      ))}
    </ul>
  );
};

export default FitRow;
